export const RANKING_RESELLER_BLACK = 4;
export const RANKING_RESELLER_DIAMOND = 3;
export const RANKING_RESELLER_GOLD = 2;
export const RANKING_RESELLER_SILVER = 1;
export const RANKING_RESELLER_BRONZE = 0;
